import type {z} from "zod";

import {AddServiceFunctionBody} from "@project/sdk/engineering/zod";

export const addServiceFunctionFormSchema = AddServiceFunctionBody;
export type AddServiceFunctionFormPayload = z.output<typeof addServiceFunctionFormSchema>;

export const draftAddServiceFunctionFormSchema = addServiceFunctionFormSchema.partial();
export type DraftAddServiceFunctionFormPayload = z.output<typeof draftAddServiceFunctionFormSchema>;
